import { Component } from '@angular/core';

@Component({
  selector: 'app-verified-header-th',
  standalone: true,
  imports: [],
  templateUrl: './verified-header-th.component.html',
})
export class VerifiedHeaderComponentTh {

}
